import { render, staticRenderFns } from "./ReservationEditor.vue?vue&type=template&id=9c0fed34&"
import script from "./ReservationEditor.vue?vue&type=script&lang=js&"
export * from "./ReservationEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports